import script from "./or-edit-logs.vue?vue&type=script&setup=true&lang=js"
export * from "./or-edit-logs.vue?vue&type=script&setup=true&lang=js"

import "./or-edit-logs.vue?vue&type=style&index=0&id=e38b27ea&scoped=true&lang=css"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e38b27ea"]])

export default __exports__